'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ListingsContainer = require('./ListingsContainer');

var _ListingsContainer2 = _interopRequireDefault(_ListingsContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ListingsContainer2.default;


//////////////////
// WEBPACK FOOTER
// ./lib/listings/index.js
// module id = 561
// module chunks = 0